import { atom } from "jotai";
import { atomFamily } from "jotai/utils";
import { Page } from "../types";

interface ErrorJson {
  errors: string[];
}

class FetchPagesError extends Error {
  status?: number;
  json?: ErrorJson;

  constructor(message: string, status?: number, json?: ErrorJson) {
    super(message);
    this.name = "FetchPagesError";
    this.status = status;
    this.json = json;
  }
}

export const interfacesPagesAtomFamily_SUSPENDS = atomFamily(
  (projectId: string) => {
    const pagesAtom = atom<Promise<Page[]>>(async () => {
      try {
        const res = await fetch(`/api/canvasui/interfaces/${projectId}/pages`);

        if (!res.ok) {
          const errorResponse = await res.json().catch(() => ({
            errors: ["Error parsing interfaces pages response data"],
          }));

          throw new FetchPagesError(res.statusText, res.status, errorResponse);
        }

        return await res.json();
      } catch (error) {
        console.error(
          `Failed to fetch pages for interface id: ${projectId}`,
          error,
        );
        return [];
      }
    });

    pagesAtom.debugLabel = `interfacesPagesAtomFamily_SUSPENDS(${projectId})`;
    return pagesAtom;
  },
);
